namespace Gamification.Gamification {
    export namespace ApiTipiOperazioniService {
        export const baseUrl = 'Gamification/ApiTipiOperazioni';

        export declare function Create(request: Serenity.SaveRequest<ApiTipiOperazioniRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<ApiTipiOperazioniRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<ApiTipiOperazioniRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<ApiTipiOperazioniRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "Gamification/ApiTipiOperazioni/Create",
            Update = "Gamification/ApiTipiOperazioni/Update",
            Delete = "Gamification/ApiTipiOperazioni/Delete",
            Retrieve = "Gamification/ApiTipiOperazioni/Retrieve",
            List = "Gamification/ApiTipiOperazioni/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>ApiTipiOperazioniService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
